import React, { ReactNode } from 'react';
import ErrorBoundary from './ErrorBoundary';
import Loading from './Loading';

interface LazyPageProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * 懒加载页面包装组件 —— 同时提供 Suspense 加载状态 和 ErrorBoundary 错误兜底
 * 替代直接在 Route 中写 <React.Suspense>
 */
const LazyPage: React.FC<LazyPageProps> = ({ children, fallback }) => (
  <ErrorBoundary>
    <React.Suspense fallback={fallback || <Loading fullPage />}>
      {children}
    </React.Suspense>
  </ErrorBoundary>
);

export default LazyPage;
